import React from "react";

const STEPS = [
  { key: "quote", label: "Cotización" },
  { key: "kyc", label: "Verificación" },
  { key: "payment", label: "Pago" },
  { key: "done", label: "Completado" },
];

export default function Stepper({ activeKey }) {
  const activeIndex = STEPS.findIndex((s) => s.key === activeKey);
  return (
    <ol className="stepper">
      {STEPS.map((step, i) => (
        <li
          key={step.key}
          className={`stepper-item ${i === activeIndex ? "is-active" : ""} ${i < activeIndex ? "is-done" : ""}`}
        >
          <span className="stepper-index">{String(i + 1).padStart(2, "0")}</span>
          <span className="stepper-label">{step.label}</span>
        </li>
      ))}
    </ol>
  );
}
